exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4[data-v-4f436981]{color:#fff!important;font-family:OpenSans!important;padding:10px 0;font-size:.9rem}", ""]);

// exports
